export default {
  dbl_home_header_title: '主页',
  dbl_home_quick_analysis: '快捷分析',
  dbl_home_dashboard: '报表中心',
  dbl_home_dashboard_desc: '创建报表',
  dbl_home_chart: '图表中心',
  dbl_home_chart_desc: '设计图表',
  dbl_home_tables: '数据管理',
  dbl_home_tables_desc: '管理数据源',
  dbl_home_user_group: '用户群分析',
  dbl_home_user_group_desc: '管理用户群',

  dbl_home_getting_start_title: '开始',
  dbl_home_getting_start_info: '以下是新用户常做的一些任务，将有助于您开展项目。',
  dbl_home_getting_start_learn: '了解更多',
  dbl_home_getting_start_know: '我知道了',
  dbl_home_getting_start_not_show: '跳过',

  dbl_home_recently_view: '最近访问',
  dbl_home_table_name: '名称',
  dbl_home_table_category: '类别',
  dbl_home_table_recently_view_time: '最近访问时间',
  dbl_home_table_owner: '所有者',
  dbl_home_share_with_me: '与我分享({count})',
  dbl_home_search_name: '搜索名称',
  dbl_home_search_dashboard_name: '搜索报表名称',
  dbl_home_table_share_time: '分享时间',
  dbl_home_search_template_placeholder: '搜索模板名称',
  dbl_home_search_dashboard_placeholder: '搜索报表或图表名称',

  dbl_home_template_center: '模板中心({count})',
  dbl_home_sub_all: '全部({count})',
  dbl_home_sub_game: '游戏模板({count})',
  dbl_home_sub_public: '公共模板({count})',
  dbl_home_sub_card: '卡片',
  dbl_home_sub_table: '表格',
  dbl_home_table_total: "共{total}项",
  dbl_home_created_by: "创建人",
  dbl_home_dashboard_name: "报表名称",
  dbl_home_template_name: "模板名称",
  dbl_home_dashboard_creator: "创建者",
  dbl_home_dashboard_visits: "访问量",
  dbl_home_dashboard_create_time: "创建时间",

};
